/* eslint-disable */
import algoliasearch from 'algoliasearch'
import instantsearch from 'instantsearch.js'
import {
  configure,
  refinementList,
  infiniteHits,
  menuSelect,
  sortBy,
} from 'instantsearch.js/es/widgets'

// import emitter from '../utils/emitter'
import moment from 'moment'
import slugify from '../utils/slugify'
import truncate from '../utils/truncate'

import translate from '../translations'

import downloadTpl from './cards-templates/download'
import eventTpl from './cards-templates/event'
import jobTpl from './cards-templates/job'
import memberTpl from './cards-templates/member'
import newsTpl from './cards-templates/news'
import pageTpl from './cards-templates/page'
import pressReleaseTpl from './cards-templates/press-release'
import pressSummaryTpl from './cards-templates/press-summary'
import reportTpl from './cards-templates/report'
import socialNetworkTpl from './cards-templates/social-network'

/* global config */

import {
  connectInfiniteHits,
  connectRefinementList,
  connectClearRefinements,
  connectMenu,
} from 'instantsearch.js/es/connectors'

export default {
  name: 'page-list-filters',

  hitsPerPage: 12,
  hitsDisplayed: 0,
  firstLoading: true,

  website: document.querySelector('body').getAttribute('data-site'),

  ui: {},

  events: [],

  componentDidMount() {
    this.listTop = document.querySelector('.page-list__wrapper--top')
    this.listBottom = document.querySelector('.page-list__wrapper--bottom')

    this.locale = document.querySelector('html').getAttribute('lang')
    moment.locale(this.locale)

    this.type = this.props.type === 'all' ? '' : this.props.type
    this.preDefinedTags = this.props.tags ? this.props.tags.split(',') : []
    this.facetFilters = []
    // to switch from AND to OR : https://www.algolia.com/doc/api-reference/api-parameters/facetFilters/
    this.facetFilters[0] = []
    //
    this.sourceType = this.type

    this.search = instantsearch({
      indexName: `${config.algolia.env}_pages`,
      searchClient: algoliasearch(
        config.algolia.applicationID,
        config.algolia.apiKey
      ),
      numberLocale: this.locale,
      routing: true,
    })

    if (this.preDefinedTags.length <= 0) {
      if (this.type !== 'job-card') {
        this.manageSelect()
        this.manageMultipleFacets()
      }
    } else {
      // if (this.props.type === 'all') {
      this.el.classList.remove('flex')
      this.el.classList.add('hidden')
    }

    // this.manageResetFacets()
    this.manageResults()

    let activeFilters = this.type !== '' ? `type:${this.type}` : ''

    switch (this.type) {
      case 'news':
        activeFilters = `type:${this.type} AND contentProperties.event:false`
        break
      case 'event':
        this.type = 'news'
        activeFilters = `type:${this.type} AND contentProperties.event:true`
        break
      case 'report':
        this.type = 'document'
        activeFilters = `type:${this.type} AND contentProperties.type:"report"`
        break
      case 'brochure':
        this.type = 'document'
        activeFilters = `type:${
          this.type
        } AND contentProperties.type:"brochure"`
        break
      case 'program':
        this.type = 'document'
        activeFilters = `type:${this.type} AND contentProperties.type:"program"`
        break
    }

    if (this.type === 'news' || this.type === 'event') {
      activeFilters += ` AND contentProperties.website:${this.website}`
    }

    if (activeFilters !== '') activeFilters += ' AND'

    activeFilters += ` locale:${this.locale}`
    activeFilters += ` AND NOT objectID:${this.props.pageId}`
    activeFilters += ' AND visible:true'

    if (this.preDefinedTags.length >= 0) {
      /* for (const tag of this.preDefinedTags) {
        this.facetFilters[0].push(`tags.name:${tag}`)
      }*/
      // REFACT FOR IE 11
      this.preDefinedTags.forEach(tag => {
        this.facetFilters[0].push(`tags.name:${tag}`)
      })
    }

    this.search.addWidgets([
      configure({
        hitsPerPage: this.hitsPerPage,
        filters: activeFilters,
        facetFilters: this.facetFilters,
        // distinct: true,
      }),
    ])

    this.search.start()
  },

  manageMultipleFacets() {
    // 1. Create a render function
    const renderRefinementList = (renderOptions, isFirstRender) => {
      const {
        items,
        isFromSearch,
        refine,
        createURL,
        isShowingMore,
        canToggleShowMore,
        searchForItems,
        toggleShowMore,
        widgetParams,
      } = renderOptions

      const button = this.el.querySelector('.bt')

      if (isFirstRender) {
        button.addEventListener('click', () => {
          toggleShowMore()
        })
      }

      if (isShowingMore) {
        button.classList.add('tag--less')
        button.innerText = translate('LESS_TAGS')
      } else {
        button.classList.remove('tag--less')
        button.innerText = translate('MORE_TAGS')
      }

      widgetParams.container.innerHTML = items
        .map(
          item => `
            <li class="facets__item">
              <a class="tag ${
                item.isRefined ? 'tag--selected' : ''
              } tag--${slugify(item.value)}"
                href="${createURL(item.value)}"
                data-value="${item.value}"
                data-text="${item.value}"
              >
                ${item.label}
                <div class="bg-color color-${slugify(item.value)}"></div>
              </a>
            </li>
          `
        )
        .join('')
      ;[...widgetParams.container.querySelectorAll('a')].forEach(element => {
        element.addEventListener('click', event => {
          event.preventDefault()
          refine(event.currentTarget.dataset.value)
          this.hitsDisplayed = 0
          /* if (this.isMobile) {
            setTimeout(_ => {
              this.closeFilterSelect()
            }, 400)
          } */
        })
      })
    }

    // 2. Create the custom widget
    const customRefinementList = connectRefinementList(renderRefinementList)
    // 3. Instantiate
    this.search.addWidgets([
      customRefinementList({
        container: this.el.querySelector('.facets-wrapper'),
        attribute: 'tags.name',
        limit: 4,
        showMore: true,
        showMoreLimit: 200,
        sortBy: ['count:desc', 'name:asc'],
        operator: 'or',
      }),
    ])
  },

  manageUniqueFacets() {
    // 1. Create a render function
    const renderMenu = (renderOptions, isFirstRender) => {
      const {
        items,
        refine,
        createURL,
        isShowingMore,
        canToggleShowMore,
        toggleShowMore,
        widgetParams,
      } = renderOptions

      const button = this.el.querySelector('.bt')

      if (isFirstRender) {
        button.addEventListener('click', () => {
          toggleShowMore()
        })
      }

      if (isShowingMore) {
        button.classList.add('tag--less')
        button.innerText = translate('LESS_TAGS')
      } else {
        button.classList.remove('tag--less')
        button.innerText = translate('MORE_TAGS')
      }

      widgetParams.container.innerHTML = items
        .map(
          item => `
            <li class="facets__item">
              <a class="tag ${
                item.isRefined ? 'tag--selected' : ''
              } tag--${slugify(item.value)}"
                href="${createURL(item.value)}"
                data-value="${slugify(item.value)}"
              >
                ${item.label}
              </a>

            </li>
          `
        )
        .join('')
      ;[...widgetParams.container.querySelectorAll('a')].forEach(element => {
        element.addEventListener('click', event => {
          event.preventDefault()
          refine(event.currentTarget.dataset.value)
          this.hitsDisplayed = 0
          /* if (this.isMobile) {
            setTimeout(_ => {
              this.closeFilterSelect()
            }, 400)
          } */
        })
      })
    }

    // 2. Create the custom widget
    const customMenu = connectMenu(renderMenu)

    // 3. Instantiate
    this.search.addWidget(
      customMenu({
        container: this.el.querySelector('.facets-wrapper'),
        attribute: 'tags.name',
        limit: 4,
        showMore: true,
        showMoreLimit: 20,
        sortBy: ['count:desc', 'name:asc'],
      })
    )
  },

  manageResetFacets() {
    // Create the render function
    const renderClearRefinements = (renderOptions, isFirstRender) => {
      const { hasRefinements, refine, widgetParams } = renderOptions

      if (isFirstRender) {
        const button = document.createElement('button')
        button.classList.add('bt-reset-filters')
        button.textContent = 'X Supprimer les filtres'

        button.addEventListener('click', () => {
          this.hitsDisplayed = 0
          renderOptions.refine()
        })
        widgetParams.container.appendChild(button)
      }

      widgetParams.container.querySelector(
        'button.bt-reset-filters'
      ).disabled = !hasRefinements
      // if (!isFirstRender) this.search.refresh();
    }

    // Create the custom widget
    const customClearRefinements = connectClearRefinements(
      renderClearRefinements
    )

    // Instantiate the custom widget
    this.search.addWidget(
      customClearRefinements({
        container: this.el.querySelector('.uppon-title'),
        clearsQuery: true,
      })
    )
  },

  manageSelect() {
    // Create the render function
    const renderMenuSelect = (renderOptions, isFirstRender) => {
      const { items, canRefine, refine, widgetParams } = renderOptions

      // if (isFirstRender) {
      if (this.el.querySelectorAll('select option').length <= 1) {
        const select = this.el.querySelector('select')
        if (isFirstRender) {
          select.addEventListener('change', event => {
            setTimeout(() => {
              this.hitsDisplayed = 0
              refine(select.value)
            }, 150)
          })
        }

        //const select = this.el.querySelector('select') // widgetParams.container.querySelector('select');

        select.disabled = !canRefine

        // select.empty();

        select.innerHTML = `
          <option value="">${translate('YEAR')}</option>
          ${items
            .map(
              item =>
                `<option
                  value="${item.value}"
                  ${item.isRefined ? 'selected' : ''}
                >
                  ${item.label}
                </option>`
            )
            .join('')}
        `
      }
    }

    // Create the custom widget
    const customMenuSelect = connectMenu(renderMenuSelect)

    // Instantiate the custom widget
    this.search.addWidgets([
      customMenuSelect({
        container: document.querySelector('.custom-select'),
        attribute: 'year',
      }),
    ])
  },

  manageResults() {
    // Create the render function
    const renderInfiniteHits = (renderOptions, isFirstRender) => {
      const { hits, showMore, isLastPage, widgetParams } = renderOptions
      // first render, construct empty ul && button more
      if (isFirstRender) {
        const button = document.createElement('button')
        button.classList.add('bt', 'tag', 'tag--more')
        button.textContent = translate('MORE_RESULTS')

        button.addEventListener('click', () => {
          showMore()
        })

        widgetParams.container.parentNode.appendChild(button)

        return
      }

      const button = widgetParams.container.parentNode.querySelector(
        'button.bt'
      )

      isLastPage
        ? button.classList.add('hidden')
        : button.classList.remove('hidden')

      let fragment = document.createDocumentFragment()
      let cards = []
      const sliceHits = hits.slice(
        this.hitsDisplayed,
        this.hitsDisplayed + this.hitsPerPage
      )

      if (this.type === 'press-summary' /* || this.type === 'article' */) {
        // Si on st dans NEWS ou ARTICLES on réordonne par date
        /* sliceHits.sort(function (a, b) {
          return new Date(b.date.date) - new Date(a.date.date)
        }) */
      }

      if (this.hitsDisplayed === 0) {
        this.listTop.innerHTML = ''
        if (this.listBottom) this.listBottom.innerHTML = ''
      }

      sliceHits.forEach((hit, index) => {
        let card = this.getCard(hit, index)
        if (!card) return
        if (this.hitsDisplayed === 0 && index < 4) {
          this.listTop.appendChild(card)
        } else {
          fragment.appendChild(card)
        }
        cards.push(card)
      })

      if (this.listBottom) {
        this.listBottom.appendChild(fragment)
        this.listBottom.classList.remove('hidden')
      } else {
        this.listTop.appendChild(fragment)
      }
      this.listTop.classList.remove('hidden')

      this.hitsDisplayed += this.hitsPerPage

      this.triggerResizeForHeaderCalculation()
    }

    // Create the custom widget
    const customInfiniteHits = connectInfiniteHits(renderInfiniteHits)

    // Instantiate the custom widget
    this.search.addWidget(
      customInfiniteHits({
        container: this.el,
      })
    )
  },

  getCard(hit) {
    // console.log(hit)

    let globalType =
      hit._highlightResult && hit._highlightResult.type
        ? hit._highlightResult.type.value
        : this.type

    let cardType = this.type === '' ? globalType : this.sourceType

    if (cardType === 'news' && hit.contentProperties.event) {
      cardType = 'event'
    }

    // console.log(globalType, '>', cardType)

    let card = document.createElement('div')
    card.classList.add('card')

    const data = {}

    const mediaPath = `//${config.cloudinary.host}/${
      config.cloudinary.options.cloud_name
    }/`

    let imgW = 650
    let imgH = 400
    if (globalType === 'document') {
      imgW = 280
      imgH = 363
    }

    // console.log(hit)

    data.imgSrc =
      hit.contentProperties.picture &&
      hit.contentProperties.picture.singleMedia.publicId
        ? `${mediaPath}/c_fill,f_auto,q_auto,g_north,w_${imgW},h_${imgH}/${
            hit.contentProperties.picture.singleMedia.publicId
          }.${hit.contentProperties.picture.singleMedia.originalFormat}`
        : ''

    data.fileURL =
      hit.contentProperties && hit.contentProperties.pdf
        ? hit.contentProperties.pdfLink
          ? hit.contentProperties.pdfLink
          : `${mediaPath}image/upload/${
              hit.contentProperties.pdf.singleMedia.publicId
            }.${hit.contentProperties.pdf.singleMedia.originalFormat}`
        : ''

    data.date = ''
    if (hit.contentProperties.date) {
      const formattedDate = moment(hit.contentProperties.date.date).format(
        'D MMM YYYY'
      )
      data.date = `<div class="date mb-2">${formattedDate}</div>`
    }

    data.title =
      hit.contentProperties && hit.contentProperties.title
        ? hit.contentProperties.title
        : hit.title
    data.desc =
      hit.customProperties && hit.customProperties.excerpt
        ? hit.customProperties.excerpt
        : hit.description
        ? hit.description
        : ''

    data.tag = ''
    if (hit.tags) {
      const t = hit.tags.length > 0 ? hit.tags[0] : { name: '' }
      if (t.name != '') {
        const tagLink = `${window.location.href.split('?')[0]}?${
          config.algolia.env
        }_pages%5BrefinementList%5D%5Btags.name%5D%5B0%5D=${slugify(t.name)}`
        data.tag += `<a href="${tagLink}" class="tag tag--${slugify(
          t.name
        )} tag--selected" data-text="${t.name}">
              <div class="bg-color color-${slugify(t.name)}"></div>
          ${t.name}
          </a>`
      }
    }

    // Try ---> fix ?
    if (hit._highlightResult && hit._highlightResult.contentProperties) {
      data.url =
        typeof hit._highlightResult.contentProperties.url != 'undefined'
          ? hit._highlightResult.contentProperties.url.value
          : hit.path
    } else {
      data.url = hit.path
    }

    data.socialnetwork = {}
    data.socialnetwork.type = hit.contentProperties.type
      ? hit.contentProperties.type
      : ''
    data.socialnetwork.name = hit.contentProperties.name
      ? hit.contentProperties.name
      : ''
    data.socialnetwork.content = hit.contentProperties.excerpt
      ? hit.contentProperties.excerpt
      : ''
    data.socialnetwork.url =
      hit._highlightResult &&
      hit._highlightResult.contentProperties &&
      hit._highlightResult.contentProperties.url
        ? hit._highlightResult.contentProperties.url.value
        : ''
    // console.log(hit)
    switch (globalType) {
      default:
      case 'document':
        if (cardType === 'report') {
          card.classList.add('card--report')
          card.innerHTML = reportTpl(data)
        } else {
          // brochure && programm
          card.classList.add('card--download')
          card.innerHTML = downloadTpl(data)
        }
        break
      case 'news':
        // looks crazy but hey, who isn't?
        if (
          hit._highlightResult &&
          hit._highlightResult.contentProperties &&
          hit._highlightResult.contentProperties.website &&
          hit._highlightResult.contentProperties.website.value === this.website
        ) {
          if (cardType === 'event') {
            card.classList.add('card--event', 'min-h-1/2')
            card.innerHTML = eventTpl(data)
          } else {
            card.classList.add('card--actu', 'min-h-1/2')
            card.innerHTML = newsTpl(data)
          }
        } else {
          card = null
        }

        break
      case 'job-card':
        card.classList.add('card--job', 'min-h-1/2')
        card.innerHTML = jobTpl(data)
        break
      case 'press-release':
        card.classList.add('card--news', 'min-h-1/2')
        card.innerHTML = pressReleaseTpl(data)
        break
      case 'press-summary':
        data.desc = truncate(data.desc, 450)
        card.classList.add('card--actu')
        card.innerHTML = pressSummaryTpl(data)
        break
      case 'social-network':
        card.classList.add('card--social-media', 'min-h-1/2')
        card.innerHTML = socialNetworkTpl(data)
        break
    }

    return card
  },

  triggerResizeForHeaderCalculation() {
    var resizeEvent = window.document.createEvent('UIEvents')
    resizeEvent.initUIEvent('resize', true, false, window, 0)
    window.dispatchEvent(resizeEvent)
  },
}
